module.exports = __webpack_public_path__ + "img/pay_size5.fd6885bf.png";